const PARTNER_AOA = "aoa";
const PARTNER_TAGTHAI = "tagthai";
const PARTNER_OPENRICE = "openrice";

const partnerNames = [PARTNER_AOA, PARTNER_TAGTHAI, PARTNER_OPENRICE];

const defaultPartner = {
  name: "",
  logo: "",
};

const hhPartners = [
  {
    name: PARTNER_AOA,
    logo: "hh-xplore-logo.svg",
  },
  {
    name: PARTNER_TAGTHAI,
    logo: "HhxTt.png",
  },
  {
    name: PARTNER_OPENRICE,
    logo: "hh-openrice-logo.svg",
  },
];

function usePartner() {
  let partner = defaultPartner;
  const urlParams = new URLSearchParams(window.location.search);
  const partnerParam = urlParams.get("partner");
  if (partnerParam === PARTNER_AOA) {
    partner = hhPartners.find((p) => p.name === PARTNER_AOA) || defaultPartner;
  } else if (partnerParam === PARTNER_TAGTHAI) {
    partner =
      hhPartners.find((p) => p.name === PARTNER_TAGTHAI) || defaultPartner;
  } else if (partnerParam === PARTNER_OPENRICE) {
    partner =
      hhPartners.find((p) => p.name === PARTNER_OPENRICE) || defaultPartner;
  }

  const isPartner = (name = "") => {
    if(name){
      return partner.name === name;
    } else {
      return partnerNames.includes(partner.name);
    }
  };

  return {
    partner,
    isPartner,
  };
}

export { usePartner };
export { PARTNER_AOA, PARTNER_TAGTHAI, PARTNER_OPENRICE };
